import React from 'react';
import { Element } from 'react-scroll';

export default function ContactMe() {
    return (
        <Element name="Contact">
            <section id="Contact" className="contact--section">
            <div>
                {/* <p className="section--title">Get In Touch</p> */}
                <h2 className='section--heading' data-aos="fade-up" data-aos-offset="300" data-aos-easing="ease-in-sine">Contact Me</h2>
            </div>
            <form className="contact--form--container" action="https://formspree.io/f/xknddzlr" method="post" data-aos="zoom-in-down" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div className="container">
                    <label htmlFor="first-name" className="contact--label">
                        <span className="text-md">
                            Your Name
                        </span>
                        <input 
                        type="text"
                        className="contact--input text-md"
                        name="first-name"
                        id="first-name" 
                        placeholder="Enter your name"
                        required
                        />
                    </label>
                    <label htmlFor="email" className="contact--label">
                        <span className="text-md">
                            Email Address
                        </span>
                        <input 
                        type="email"
                        className="contact--input text-md"
                        name="email"
                        id="email" 
                        placeholder="Enter your email address"
                        required
                        />
                    </label>
                </div>
                    <label htmlFor="message" className="contact--label">
                        <span className="text-md">
                            Your Message
                        </span>
                        <textarea 
                        className="contact--input text-md" name="message" 
                        id="message" 
                        rows="3" 
                        placeholder="Type your message..."
                        required
                        />
                    </label>
                    <div>
                        <button className="btn btn-primary contact--form--btn">Submit</button>
                    </div>
            </form>
            </section>
        </Element>
    );
}